import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ChaveValor } from '../../../../interfaces/segmentacao/chave-valor.interface';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SegmentacaoService } from '../../../../services/segmentacao.service';
import { TipoFiltro } from '../../../../enums/tipo-filtro.enum';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-filtro-checkbox',
    templateUrl: './filtro-checkbox.component.html',
    styleUrls: ['./filtro-checkbox.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FiltroCheckboxComponent implements OnInit {
    @Input() titulo: string = '';
    @Input() subTitulo: string = '';
    @Input() tipoFiltro!: TipoFiltro;
    @Input() permiteExcluirTodos: boolean = true;
    @Input() itensSelecionados: ChaveValor[] | undefined = [];
    @Input() propriedadeDestino!: keyof any;

    @Output() salvar = new EventEmitter<ChaveValor[]>();
    @Output() cancelar = new EventEmitter<void>();

    loading: boolean = false;
    opcoesDisponiveis: ChaveValor[] = [];
    itensSelecionadosInterno: ChaveValor[] = [];

    constructor(private segmentacaoService: SegmentacaoService, private cdr: ChangeDetectorRef, private toastr: ToastrService) { }

    ngOnInit(): void {
        this.carregarOpcoes();
    }

    async carregarOpcoes(): Promise<void> {
        this.loading = true;
        const data = await this.segmentacaoService.listarFiltro({ tipo: this.tipoFiltro });    
        this.itensSelecionadosInterno = data?.filter(i => this.itensSelecionados?.some(s => s.chave === i.chave)) || [];
        this.opcoesDisponiveis = data || [];
        this.loading = false;
    }

    adicionarRemoverFiltro(item: ChaveValor): void {
        if (!item) return;

        if (!this.itensSelecionadosInterno.some(i => i.chave === item.chave)) {
            this.itensSelecionadosInterno.push(item);
        } else {
            this.itensSelecionadosInterno = this.itensSelecionadosInterno.filter(opcao => opcao.chave !== item.chave);
        }
    }

    removerFiltro(item?: ChaveValor, removerTodos: boolean = false): void {
        if (removerTodos) {
            this.itensSelecionadosInterno = [];
        } else {
            if (!item) return;
            this.itensSelecionadosInterno = this.itensSelecionadosInterno.filter(f => f.chave !== item?.chave);
        }
    }

    verificarItensSelecionados(item: ChaveValor): boolean {
        return this.itensSelecionadosInterno.some(i => i.chave === item.chave);
    }

    salvarFiltro(): void {
        if(!this.validarSelecao()) {
            return;
        }            

        this.salvar.emit(this.itensSelecionadosInterno);
    }

    validarSelecao(): boolean {
        if(!this.permiteExcluirTodos && this.itensSelecionadosInterno.length === 0) {
            this.toastr.error('Selecione pelo menos um item');
            return false;
        }
        return true;
    }

    cancelarFiltro(): void {
        this.itensSelecionadosInterno = [...(this.itensSelecionados ?? [])];
        this.cancelar.emit();
    }
}
